// import React from "react";
import { useState,useEffect } from "react";
// import { Navigate } from "react-router-dom";
import axios from "axios";
// import { useSelector } from "react-redux";
const SERVER_URL = process.env.REACT_APP_SERVER_URL

const SignOut = (props) => {
  // eslint-disable-next-line no-unused-vars
  const [redirect,setRedirect] = useState(false);
  // const { cartProducts, totalQuantities, totalPrice, myOrders,totalAmount } = useSelector(
  //   (state) => state.cartReducer
  // );
  // const dispatch = useDispatch();
  useEffect(() => {
    console.log(2);
    const cart_Products = JSON.parse(localStorage.getItem("productsInCart")) || [];
    const token = JSON.parse(localStorage.getItem("userTokenTime")).token
    console.log(cart_Products);
    console.log(token);
      localStorage.removeItem("userTokenTime");
        localStorage.removeItem("productsInCart"); 
        // dispatch({ type: "CART_EMPTY" });
        // console.log(cartProducts);
    axios
      .post(
        SERVER_URL+"/api/signout",
        {
          cart: cart_Products,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "Bearer " +
              token,
          },
        }
      )
      .then((res) => {

        console.log("signed out successfully!");
        setRedirect(true);
        window.location = process.env.REACT_APP_LINK

      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  // if (localStorage.getItem("userTokenTime")) {
  //   console.log(1);
  //   localStorage.removeItem("userTokenTime");
  //       localStorage.removeItem("productsInCart"); 
  // }
  // if(redirect)
  // return <Navigate to="/" />;
};

export default SignOut;
